export function ucFirst(x: string): string {
  return x[0].toUpperCase() + x.slice(1);
}
